import react from "react";
import { Link } from "react-router-dom";



export default function Sidebar() {
    return (
    
        <>
        
        
        <div className="elementor-widget-wrap elementor-element-populated">
                            <section
                              className="elementor-section elementor-inner-section elementor-element elementor-element-2c8f4f2e elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="2c8f4f2e"
                              data-element_type="section"
                            >
                              <div className="elementor-container elementor-column-gap-no">
                                <div
                                  className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-64890080"
                                  data-id={64890080}
                                  data-element_type="column"
                                  data-settings='{"background_background":"classic"}'
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-389f4121 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="389f4121"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <Link to="/solid-waste-management">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className=" icon-41"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Solid Waste Management
                                              </span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-43a4e512 wastix_list_category_01 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="43a4e512"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <Link to="/hazardous-waste-management">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className=" icon-41"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Hazardous Waste Management
                                              </span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-6a2d2b14 wastix_list_category_01 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="6a2d2b14"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <Link to="/bio-medical-waste-management">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className=" icon-41"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Bio-Medical Waste Management
                                              </span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-46f3500e wastix_list_category_01 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="46f3500e"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <Link to="/faecal-sludge-waste-management">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className=" icon-41"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Faecal Sludge Management
                                              </span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-2db44f71 wastix_list_category_01 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="2db44f71"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <Link to="/manpower-services-and-staffing">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className=" icon-41"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Manpower Services and Staffing
                                              </span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                   
                                     <div
                                      className="elementor-element elementor-element-2db44f71 wastix_list_category_01 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="2db44f71"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <Link to="/liquid-waste-management">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className=" icon-41"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                
                                                 Liquid Waste Management
                                              </span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                     <div
                                      className="elementor-element elementor-element-2db44f71 wastix_list_category_01 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="2db44f71"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <Link to="/construction">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className=" icon-41"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                
                                                 Construction
                                              </span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    
                                     <div
                                      className="elementor-element elementor-element-2db44f71 wastix_list_category_01 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="2db44f71"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <Link to="/facilitymanagement">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className=" icon-41"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                
                                                Facility Management
                                              </span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                     <div
                                      className="elementor-element elementor-element-2db44f71 wastix_list_category_01 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="2db44f71"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <Link to="/securityservices">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className=" icon-41"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                
                                                Security Services
                                              </span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                     <div
                                      className="elementor-element elementor-element-2db44f71 wastix_list_category_01 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                      data-id="2db44f71"
                                      data-element_type="widget"
                                      data-widget_type="icon-list.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <ul className="elementor-icon-list-items">
                                          <li className="elementor-icon-list-item">
                                            <Link to="/conservancyservices">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className=" icon-41"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                               
                                                Conservancy Services
                                              </span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                           
                            <section
                              className="elementor-section elementor-inner-section elementor-element elementor-element-4af48d44 elementor-section-boxed elementor-section-height-default elementor-section-height-default gt"
                              data-id="4af48d44"
                              data-element_type="section"
                            >
                              <div className="elementor-container elementor-column-gap-no">
                                <div
                                  className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-2841cc46"
                                  data-id="2841cc46"
                                  data-element_type="column"
                                  data-settings='{"background_background":"classic"}'
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-4480e3e0 elementor-view-stacked wastix_icon_08 elementor-shape-circle elementor-widget elementor-widget-icon"
                                      data-id="4480e3e0"
                                      data-element_type="widget"
                                      data-widget_type="icon.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <div className="elementor-icon-wrapper">
                                          <div className="elementor-icon">
                                            <svg
                                              aria-hidden="true"
                                              className="e-font-icon-svg e-fas-headphones-alt"
                                              viewBox="0 0 512 512"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path d="M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z" />
                                            </svg>{" "}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-be50197 elementor-widget elementor-widget-heading"
                                      data-id="be50197"
                                      data-element_type="widget"
                                      data-widget_type="heading.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <h2 className="elementor-heading-title elementor-size-default">
                                          Do You Need
                                          <br />
                                          Any Help?
                                        </h2>{" "}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <section
                              className="elementor-section elementor-inner-section elementor-element elementor-element-2159bf6e elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="2159bf6e"
                              data-element_type="section"
                              data-settings='{"background_background":"classic"}'
                            >
                              <div className="elementor-container elementor-column-gap-no">
                                <div
                                  className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-681d0de1"
                                  data-id="681d0de1"
                                  data-element_type="column"
                                  data-settings='{"background_background":"classic"}'
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-6dee4641 wastix_text_underline_01 elementor-widget elementor-widget-heading"
                                      data-id="6dee4641"
                                      data-element_type="widget"
                                      data-widget_type="heading.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <h2 className="elementor-heading-title elementor-size-default">
                                          gcindia01@gmail.com
                                        </h2>{" "}
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-5a991dcd wastix_text_underline_01 elementor-widget elementor-widget-heading"
                                      data-id="5a991dcd"
                                      data-element_type="widget"
                                      data-widget_type="heading.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <h2 className="elementor-heading-title elementor-size-default">
                                          (+91) 9439366515
                                        </h2>{" "}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
        
        
        </>




);

}